// langs/index.js
import { BIZ_LANGUAGE_MAP } from '@/common/constant';
import en from "./en";
import cn from "./cn";
import cht from "./cht";
import ja from "./ja"
import de from "./de"
import ms from "./ms"
import af from "./af"
import th from "./th"
import el from "./el"
import pt from "./pt"
import es from "./es"
import fr from "./fr"
import ru from "./ru"
import it from "./it"
import tr from "./tr"
import ko from "./ko"
import ph from './ph'
import ar from './ar'
import vi from './vi'
import id from './id'
import hi from './hi'
export default {
    [BIZ_LANGUAGE_MAP.zhCN]: cn,
    [BIZ_LANGUAGE_MAP.zhTW]: cht,
    [BIZ_LANGUAGE_MAP.en]: en,
    [BIZ_LANGUAGE_MAP.ja]:ja,
    [BIZ_LANGUAGE_MAP.de]:de,
    [BIZ_LANGUAGE_MAP.ms]:ms,
    [BIZ_LANGUAGE_MAP.af]:af,
    [BIZ_LANGUAGE_MAP.th]:th,
    [BIZ_LANGUAGE_MAP.el]:el,
    [BIZ_LANGUAGE_MAP.pt]:pt,
    [BIZ_LANGUAGE_MAP.es]:es,
    [BIZ_LANGUAGE_MAP.fr]:fr,
    [BIZ_LANGUAGE_MAP.ru]:ru,
    [BIZ_LANGUAGE_MAP.it]:it,
    [BIZ_LANGUAGE_MAP.tr]:tr,
    [BIZ_LANGUAGE_MAP.ko]:ko,
    [BIZ_LANGUAGE_MAP.ph]:ph,
    [BIZ_LANGUAGE_MAP.ar]:ar,
    [BIZ_LANGUAGE_MAP.id]:id,
    [BIZ_LANGUAGE_MAP.vi]:vi,
    [BIZ_LANGUAGE_MAP.hi]:hi
};
